import React from 'react';

export const Logo = (<svg version="1.1"  x="0px" y="0px"
	 viewBox="0 0 283.7 158" style={{enableBackground: 'new 0 0 283.7 158'}}>

<g>
	<path className="st0" d="M283.7,78.9c0-10.9-2.1-21.1-6.2-30.7c-4.2-9.6-9.8-17.9-17-25c-7.2-7.1-15.6-12.7-25.2-16.9
		c-9.8-4.2-20-6.3-30.9-6.3c-2.8,0-5.5,0.1-8.1,0.4H0v37.3l52.6-0.5h10.9V158H104V37.2h33.1c-2.2,3.4-4.1,7.1-5.7,10.9
		c-4.2,9.6-6.2,19.8-6.2,30.7s2.1,21.1,6.2,30.7c4.2,9.6,9.8,17.9,17,25c7.2,7.1,15.5,12.7,25.1,16.8s19.9,6.1,30.9,6.1h79.3V78.9
		L283.7,78.9z M188.8,116.4c-4.8-2.2-8.9-5.2-12.4-8.9c-3.5-3.7-6.2-8.1-8.2-13.1s-3-10.2-3-15.5c0-5.5,1-10.7,3-15.6
		s4.7-9.2,8.2-13c3.5-3.7,7.6-6.7,12.4-8.9c4.8-2.2,10-3.4,15.6-3.4s10.8,1.1,15.6,3.4c4.8,2.2,8.9,5.2,12.4,8.9s6.2,8,8.2,13
		c2,4.9,3,10.1,3,15.6c0,5.4-1,10.6-3,15.5c-2,5-4.7,9.3-8.2,13.1c-3.5,3.7-7.6,6.7-12.4,8.9c-4.8,2.2-10,3.4-15.6,3.4
		S193.6,118.6,188.8,116.4z"/>
</g>
</svg>
);



// WEBPACK FOOTER //
// ./src/components/svgs/LogedInUserLogo.jsx